<template>
  <div>
    <el-row class="public-profile do-not-print">
      <el-col>
        <el-row v-if="isPublic">
          <el-col>
            <el-row class="narrow">
              <el-col class="centered" :xl="5" :lg="5" :md="5" :sm="5">
                <span
                  v-if="
                    profile.image !== 'na' &&
                      profile.configuration.profileConfiguration
                        .personalInformation.profilePhoto &&
                      !profile.displayInitials
                  "
                >
                  <img :src="profile.image" class="image-rounded" />
                </span>
                <div v-else>
                  <span class="initials">{{ profile.initials }} </span>
                </div>
              </el-col>
              <el-col :xl="15" :lg="15" :md="15" :sm="15">
                <el-row>
                  <el-col
                    style="text-align:center"
                    v-if="profile.firstName && !profile.displayInitials"
                  >
                    <span
                      v-if="
                        profile.firstName.length > 14 ||
                          profile.surname.length > 14
                      "
                      class="cv-name email-ow"
                      style="font-size: 28px;"
                      >{{ profile.firstName.toUpperCase() }}</span
                    >
                    <span v-else class="cv-name email-ow">{{
                      profile.firstName.toUpperCase()
                    }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    style="text-align:center"
                    v-if="profile.surname && !profile.displayInitials"
                  >
                    <span
                      v-if="
                        profile.firstName.length > 14 ||
                          profile.surname.length > 14
                      "
                      class="cv-name email-ow"
                      style="font-size: 28px;"
                      >{{ profile.surname.toUpperCase() }}</span
                    >
                    <span v-else class="cv-name email-ow">{{
                      profile.surname.toUpperCase()
                    }}</span>
                  </el-col>
                </el-row>
                <el-row
                  style="margin-top:50px"
                  v-if="
                    profile.survey &&
                      profile.configuration.profileConfiguration
                        .personalInformation.seekingRole
                  "
                >
                  <el-col
                    style="text-align:center"
                    v-if="
                      profile.configuration.profileConfiguration
                        .personalInformation.seekingRoleValue
                    "
                  >
                    <span
                      class="role-title"
                      v-if="
                        profile.configuration.profileConfiguration
                          .personalInformation.seekingRole &&
                          profile.configuration.profileConfiguration
                            .personalInformation.seekingRoleValue != 'N/A'
                      "
                      >{{
                        profile.configuration.profileConfiguration
                          .personalInformation.seekingRoleValue
                      }}</span
                    >
                  </el-col>
                </el-row>
              </el-col>
              <el-col
                class="centered"
                :xl="4"
                :lg="4"
                :md="4"
                :sm="4"
                v-if="profile.organisationProfile"
              >
                <span v-if="profile.organisationProfile.image !== 'na'">
                  <img
                    :src="profile.organisationProfile.image"
                    class="image-rounded"
                  />
                </span>
                <div v-else>
                  <span
                    class="initials"
                    v-if="profile.organisationProfile.initials"
                    >{{ profile.organisationProfile.initials }}
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="centered">
                <el-tabs style="width: 85%">
                  <el-tab-pane>
                    <span
                      slot="label"
                      style="font-size: 18px; font-weight: bold"
                    >
                      <i>Your</i> Digital Business Card</span
                    >
                    <el-row class="centered">
                      <el-col :xl="5" :lg="5" :md="5" :sm="5" :xs="8">
                        <span class="cv-info-label">PERSONAL STATEMENT:</span>
                      </el-col>
                      <el-col :xl="19" :lg="19" :md="19" :sm="19" :xs="16">
                        <span class="cv-info email-ow">{{
                          profile.configuration.profileConfiguration
                            .personalStatement
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      v-if="
                        profile.configuration.profileConfiguration
                          .personalInformation.email
                      "
                    >
                      <el-col :xl="5" :lg="5" :md="5" :sm="5" :xs="8">
                        <span class="cv-info-label">EMAIL:</span>
                      </el-col>
                      <el-col :xl="19" :lg="19" :md="19" :sm="19" :xs="16">
                        <span class="cv-info email-ow">{{
                          profile.configuration.profileConfiguration
                            .personalInformation.emailValue
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      v-if="
                        profile.configuration.profileConfiguration
                          .personalInformation.address
                      "
                    >
                      <el-col :xl="5" :lg="5" :md="5" :sm="5" :xs="8">
                        <span class="cv-info-label">ZIP CODE:</span>
                      </el-col>
                      <el-col :xl="19" :lg="19" :md="19" :sm="19" :xs="16">
                        <span class="cv-info">{{
                          profile.configuration.profileConfiguration
                            .personalInformation.addressValue
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      v-if="
                        profile.configuration.profileConfiguration
                          .personalInformation.phone
                      "
                    >
                      <el-col :xl="5" :lg="5" :md="5" :sm="5" :xs="8">
                        <span class="cv-info-label">PHONE:</span>
                      </el-col>
                      <el-col :xl="19" :lg="19" :md="19" :sm="19" :xs="16">
                        <span class="cv-info">{{
                          profile.configuration.profileConfiguration
                            .personalInformation.phoneValue
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.survey.sgaEducation != null &&
                          profile.survey.sgaEducation != undefined &&
                          (profile.configuration.profileConfiguration
                            .personalInformation.education.secondaryLevel ||
                            profile.configuration.profileConfiguration
                              .personalInformation.education.thirdLevel ||
                            profile.configuration.profileConfiguration
                              .personalInformation.education.fourthLevel)
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header">EDUCATION</span>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col
                            :offset="4"
                            :xl="18"
                            :lg="18"
                            :md="18"
                            :sm="18"
                            :xs="18"
                          >
                            <div
                              v-if="
                                profile.configuration.profileConfiguration
                                  .personalInformation.education.fourthLevel
                              "
                            >
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .fourthLevelValue.doctoralDegreeDetails !=
                                    null &&
                                    profile.configuration.profileConfiguration
                                      .personalInformation.education
                                      .fourthLevelValue.doctoralDegreeDetails
                                      .length > 0
                                "
                              >
                                <!-- Doctoral -->
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label"
                                      >DOCTORAL DEGREE</span
                                    >
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <el-row
                                      v-for="(course, index) in profile
                                        .configuration.profileConfiguration
                                        .personalInformation.education
                                        .fourthLevelValue.doctoralDegreeDetails"
                                      :key="index"
                                    >
                                      <el-col>
                                        <span class="cv-info">{{
                                          course.courseTitle
                                        }}</span>
                                        <span
                                          class="cv-info"
                                          style="word-break: break-word;"
                                          v-if="course.currentlyAttending"
                                        >
                                          - Graduation Date is
                                          {{
                                            course.graduationDate
                                              | moment("MMMM DD, YYYY")
                                          }}
                                        </span>
                                      </el-col>
                                    </el-row>
                                  </el-col>
                                </el-row>
                              </div>
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .fourthLevelValue.mastersDegreeDetails !=
                                    null &&
                                    profile.configuration.profileConfiguration
                                      .personalInformation.education
                                      .fourthLevelValue.mastersDegreeDetails
                                      .length > 0
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label"
                                      >MASTER'S DEGREE</span
                                    >
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <el-row
                                      v-for="(course, index) in profile
                                        .configuration.profileConfiguration
                                        .personalInformation.education
                                        .fourthLevelValue.mastersDegreeDetails"
                                      :key="index"
                                    >
                                      <el-col>
                                        <span class="cv-info">{{
                                          course.courseTitle
                                        }}</span>
                                        <span
                                          class="cv-info"
                                          style="word-break: break-word;"
                                          v-if="course.CurrentlyAttending"
                                        >
                                          - Graduation Date is
                                          {{
                                            course.graduationDate
                                              | moment("MMMM DD, YYYY")
                                          }}
                                        </span>
                                      </el-col>
                                    </el-row>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                            <div
                              v-if="
                                profile.configuration.profileConfiguration
                                  .personalInformation.education.thirdLevel
                              "
                            >
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .thirdLevelValue.bachelorsDegreeDetails !=
                                    null &&
                                    profile.configuration.profileConfiguration
                                      .personalInformation.education
                                      .thirdLevelValue.bachelorsDegreeDetails
                                      .length > 0
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label"
                                      >BACHELOR'S DEGREE</span
                                    >
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <el-row
                                      v-for="(course, index) in profile
                                        .configuration.profileConfiguration
                                        .personalInformation.education
                                        .thirdLevelValue.bachelorsDegreeDetails"
                                      :key="index"
                                    >
                                      <el-col>
                                        <span class="cv-info">{{
                                          course.courseTitle
                                        }}</span>
                                        <span
                                          class="cv-info"
                                          style="word-break: break-word;"
                                          v-if="course.currentlyAttending"
                                        >
                                          - Graduation Date is
                                          {{
                                            course.graduationDate
                                              | moment("MMMM DD, YYYY")
                                          }}
                                        </span>
                                      </el-col>
                                    </el-row>
                                  </el-col>
                                </el-row>
                              </div>
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .thirdLevelValue.associateDegreeDetails !=
                                    null &&
                                    profile.configuration.profileConfiguration
                                      .personalInformation.education
                                      .thirdLevelValue.associateDegreeDetails
                                      .length > 0
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label"
                                      >ASSOCIATE DEGREE</span
                                    >
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <el-row
                                      v-for="(course, index) in profile
                                        .configuration.profileConfiguration
                                        .personalInformation.education
                                        .thirdLevelValue.associateDegreeDetails"
                                      :key="index"
                                    >
                                      <el-col>
                                        <span class="cv-info">{{
                                          course.courseTitle
                                        }}</span>
                                        <span
                                          class="cv-info"
                                          style="word-break: break-word;"
                                          v-if="course.currentlyAttending"
                                        >
                                          - Graduation Date is
                                          {{
                                            course.graduationDate
                                              | moment("MMMM DD, YYYY")
                                          }}
                                        </span>
                                      </el-col>
                                    </el-row>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                            <div
                              v-if="
                                profile.configuration.profileConfiguration
                                  .personalInformation.education.secondaryLevel
                              "
                            >
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .secondaryLevelValue.aLevelDetailsValue !=
                                    null &&
                                    profile.configuration.profileConfiguration
                                      .personalInformation.education
                                      .secondaryLevelValue.aLevelDetailsValue
                                      .length > 0
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label">A LEVELS</span>
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <el-row
                                      v-for="(course, index) in profile
                                        .configuration.profileConfiguration
                                        .personalInformation.education
                                        .secondaryLevelValue.aLevelDetailsValue"
                                      :key="index"
                                    >
                                      <el-col>
                                        <span class="cv-info"
                                          >{{ course.subject }} ({{
                                            course.grade
                                          }})</span
                                        >
                                      </el-col>
                                    </el-row>
                                  </el-col>
                                </el-row>
                              </div>
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .secondaryLevelValue.oLevelDetailsValue !=
                                    null &&
                                    profile.configuration.profileConfiguration
                                      .personalInformation.education
                                      .secondaryLevelValue.oLevelDetailsValue
                                      .length > 0
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label"
                                      >O LEVELS DEGREE</span
                                    >
                                  </el-col>
                                </el-row>
                                <el-row>
                                  <el-col>
                                    <el-row
                                      v-for="(course, index) in profile
                                        .configuration.profileConfiguration
                                        .personalInformation.education
                                        .secondaryLevelValue.oLevelDetailsValue"
                                      :key="index"
                                    >
                                      <el-col>
                                        <span class="cv-info"
                                          >{{ course.subject }} ({{
                                            course.grade
                                          }})</span
                                        >
                                      </el-col>
                                    </el-row>
                                  </el-col>
                                </el-row>
                              </div>
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .secondaryLevelValue.leavingCert
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label">{{
                                      profile.configuration.profileConfiguration
                                        .personalInformation.education
                                        .secondaryLevelValue.leavingCertValue
                                    }}</span>
                                  </el-col>
                                </el-row>
                              </div>
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .secondaryLevelValue.ged
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label">{{
                                      profile.configuration.profileConfiguration
                                        .personalInformation.education
                                        .secondaryLevelValue.gedValue
                                    }}</span>
                                    <br />
                                    <span
                                      class="cv-info"
                                      style="word-break: break-word;"
                                      v-if="
                                        profile.configuration
                                          .profileConfiguration
                                          .personalInformation.education
                                          .secondaryLevelValue.gedAttending
                                      "
                                    >
                                      Graduation Date is
                                      {{
                                        profile.configuration
                                          .profileConfiguration
                                          .personalInformation.education
                                          .secondaryLevelValue
                                          .gedGraduationDate
                                          | moment("MMMM DD, YYYY")
                                      }}
                                    </span>
                                  </el-col>
                                </el-row>
                              </div>
                              <div
                                class="narrow-15"
                                v-if="
                                  profile.configuration.profileConfiguration
                                    .personalInformation.education
                                    .secondaryLevelValue.highSchoolDiploma
                                "
                              >
                                <el-row>
                                  <el-col>
                                    <span class="cv-info-label">{{
                                      profile.configuration.profileConfiguration
                                        .personalInformation.education
                                        .secondaryLevelValue
                                        .highSchoolDiplomaValue
                                    }}</span>
                                    <br />
                                    <span
                                      class="cv-info"
                                      style="word-break: break-word;"
                                      v-if="
                                        profile.configuration
                                          .profileConfiguration
                                          .personalInformation.education
                                          .secondaryLevelValue
                                          .highSchoolDiplomaAttending
                                      "
                                    >
                                      Graduation Date is
                                      {{
                                        profile.configuration
                                          .profileConfiguration
                                          .personalInformation.education
                                          .secondaryLevelValue
                                          .highSchoolDiplomaGraduationDate
                                          | moment("MMMM DD, YYYY")
                                      }}
                                    </span>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .personalInformation.certifications
                      "
                    >
                      <el-col
                        v-if="
                          profile.configuration.profileConfiguration
                            .personalInformation.certificationsValue
                            .userCertifications != null &&
                            profile.configuration.profileConfiguration
                              .personalInformation.certificationsValue
                              .userCertifications.length > 0
                        "
                      >
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header"
                              >CERTIFICATIONS</span
                            >
                          </el-col>
                        </el-row>
                        <el-row
                          style="margin-bottom:10px"
                          v-for="(cert, index) in profile.configuration
                            .profileConfiguration.personalInformation
                            .certificationsValue.userCertifications"
                          :key="index"
                        >
                          <el-col
                            :offset="4"
                            :xl="20"
                            :lg="20"
                            :md="20"
                            :sm="20"
                            :xs="20"
                          >
                            <el-row>
                              <el-col>
                                <!-- <span class="cv-info" style="color:#505050 !important">{{ getCertificateDescription(cert.CodeDeTailId) }}</span> -->
                                <span
                                  class="cv-info"
                                  style="color:#505050 !important"
                                  >{{ cert.codeDetailDesc }}</span
                                >
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col>
                                <span
                                  class="cv-info"
                                  v-if="
                                    cert.acquiredDt != '0001-01-01T00:00:00'
                                  "
                                  >Date Acquired:
                                  {{
                                    cert.acquiredDt | moment("MMMM DD, YYYY")
                                  }}</span
                                >
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col>
                                <span
                                  class="cv-info"
                                  v-if="
                                    cert.noExpiration == false &&
                                      cert.expirationDt != '0001-01-01T00:00:00'
                                  "
                                  >Expiration Date:
                                  {{
                                    cert.expirationDt | moment("MMMM DD, YYYY")
                                  }}</span
                                >
                                <span
                                  class="cv-info"
                                  v-else-if="
                                    cert.noExpiration == false &&
                                      cert.expirationDt == '0001-01-01T00:00:00'
                                  "
                                  >Expiration Date: - N/A</span
                                >
                                <span class="cv-info" v-else
                                  >Expiration Date: No Expiration</span
                                >
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane>
                    <span
                      slot="label"
                      style="font-size: 18px;font-weight: bold;"
                    >
                      <i>Your</i> Resume</span
                    >
                    <el-row
                      class="centered"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.organizationName &&
                          profile.configuration.profileConfiguration
                            .coreStrengthInformation.organizationNameValue !=
                            'n/a'
                      "
                    >
                      <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="12">
                        <span class="cv-info-label">COMPANY NAME:</span>
                      </el-col>
                      <el-col :xl="16" :lg="16" :md="16" :sm="16" :xs="12">
                        <span class="cv-info">{{
                          profile.configuration.profileConfiguration
                            .coreStrengthInformation.organizationNameValue
                        }}</span>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        this.profile.configuration.profileConfiguration
                          .coreStrengthInformation.workHistory
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header">WORK HISTORY</span>
                          </el-col>
                        </el-row>
                        <el-row
                          style="margin-bottom:10px"
                          v-for="(work, index) in profile.configuration
                            .profileConfiguration.coreStrengthInformation
                            .workHistoryValue.userWorkHistory"
                          :key="index"
                        >
                          <el-col
                            :offset="4"
                            :xl="20"
                            :lg="20"
                            :md="20"
                            :sm="20"
                            :xs="20"
                          >
                            <el-row v-if="work.jobTitleVisible">
                              <el-col>
                                <span
                                  class="cv-info"
                                  style="color:#505050 !important"
                                  >{{ work.jobTitle }}</span
                                >
                              </el-col>
                            </el-row>
                            <el-row v-if="work.workedFromVisible">
                              <el-col>
                                <span class="cv-info"
                                  >Start Date:
                                  {{
                                    work.workedFrom | moment("MMMM DD, YYYY")
                                  }}</span
                                >
                              </el-col>
                            </el-row>
                            <el-row v-if="work.workedToVisible">
                              <el-col>
                                <span
                                  v-if="work.workedToPresent == true"
                                  class="cv-info"
                                  >End Date: Present Date</span
                                >
                                <span
                                  v-if="
                                    work.workedToPresent != true &&
                                      (work.workedTo ==
                                        '0001-01-01T00:00:00Z' ||
                                        work.workedTo == null)
                                  "
                                  class="cv-info"
                                  >End Date: N/A</span
                                >
                                <span
                                  v-if="
                                    work.workedToPresent != true &&
                                      work.workedTo != '0001-01-01T00:00:00Z' &&
                                      work.workedTo != null
                                  "
                                  class="cv-info"
                                  >End Date:
                                  {{
                                    work.workedTo | moment("MMMM DD, YYYY")
                                  }}</span
                                >
                              </el-col>
                            </el-row>
                            <el-row v-if="work.employerVisible">
                              <el-col>
                                <span class="cv-info">{{ work.employer }}</span>
                              </el-col>
                            </el-row>
                            <el-row v-if="work.employerAddressVisible">
                              <el-col>
                                <span class="cv-info">{{
                                  work.employerAddress
                                }}</span>
                              </el-col>
                            </el-row>
                            <el-row v-if="work.employerNumberVisible">
                              <el-col>
                                <span class="cv-info"
                                  >{{ work.selectedCountryCode }}
                                  {{ work.employerNumber }}</span
                                >
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.taskDuties
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header">TASKS/DUTIES</span>
                          </el-col>
                        </el-row>
                        <el-row
                          v-for="(code, index1) in currentRoleCodes"
                          :key="index1"
                        >
                          <el-col>
                            <span
                              :id="'task_id_' + code"
                              class="cv-info-label"
                              v-if="selectedRoleTitle(code) != ''"
                              >{{ selectedRoleTitle(code) }}</span
                            >
                            <el-row
                              v-for="(task, index) in profile.configuration
                                .profileConfiguration.coreStrengthInformation
                                .taskDutiesValue.jobDescriptionTasks"
                              :key="index"
                            >
                              <el-col
                                :offset="3"
                                :xl="21"
                                :lg="21"
                                :md="21"
                                :sm="21"
                                :xs="21"
                              >
                                <div v-if="task.indexOf('`') > -1">
                                  <div v-if="task.split('`')[1].trim() == code">
                                    <span class="cv-info"
                                      >- {{ task.split("`")[0] }}</span
                                    >
                                  </div>
                                </div>
                                <div v-if="code == 'Others'">
                                  <div v-if="task.indexOf('`') == -1">
                                    <span class="cv-info class_Others"
                                      >- {{ task }}</span
                                    >
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                        <!-- limit
                        <el-row v-for="(task, index) in profile.Survey.SgaYourJob.JobDescriptionTasks" :key="index">
                            <el-col :offset="3" :xl="21" :lg="21" :md="21" :sm="21" :xs="21">
                              <span class="cv-info">- {{ task }}</span>
                            </el-col>
                          </el-row> -->
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.activities
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header">ACTIVITIES</span>
                          </el-col>
                        </el-row>
                        <el-row
                          v-for="(activity, index) in profile.configuration
                            .profileConfiguration.coreStrengthInformation
                            .activitiesValue.workingPracticeActivities"
                          :key="index"
                        >
                          <el-col
                            :offset="3"
                            :xl="21"
                            :lg="21"
                            :md="21"
                            :sm="21"
                            :xs="21"
                          >
                            <span class="cv-info"
                              >- {{ activity.selection }}</span
                            >
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.sectorExperience
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header"
                              >SECTOR EXPERIENCES</span
                            >
                          </el-col>
                        </el-row>
                        <el-row
                          style="margin-bottom:10px;"
                          v-for="(experience, index) in profile.configuration
                            .profileConfiguration.personalInformation.education
                            .sectorExperienceValue.experienceDetails"
                          :key="index"
                        >
                          <el-col
                            :offset="3"
                            :xl="21"
                            :lg="21"
                            :md="21"
                            :sm="21"
                            :xs="21"
                          >
                            <el-row>
                              <el-col>
                                <span class="cv-info-label">{{
                                  experience.title.toUpperCase()
                                }}</span>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col>
                                <span class="cv-info">{{
                                  experience.years
                                }}</span>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.knowledge
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header">KNOWLEDGE</span>
                          </el-col>
                        </el-row>
                        <el-row
                          style="margin-bottom:10px;"
                          v-for="(knowledge, index) in profile.configuration
                            .profileConfiguration.coreStrengthInformation
                            .knowledgeValue.knowledgeRegularlyUsed"
                          :key="index"
                        >
                          <el-col
                            :offset="3"
                            :xl="21"
                            :lg="21"
                            :md="21"
                            :sm="21"
                            :xs="21"
                          >
                            <el-row>
                              <el-col>
                                <span class="cv-info-label">{{
                                  knowledge.selection.toUpperCase()
                                }}</span>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col>
                                <span class="cv-info">{{
                                  knowledge.yearsOfExperience
                                }}</span>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.essentialSkills
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header"
                              >ESSENTIAL SKILLS</span
                            >
                          </el-col>
                        </el-row>
                        <el-row
                          v-for="(mindset, index) in profile.configuration
                            .profileConfiguration.coreStrengthInformation
                            .essentialSkillsValue.mindsets"
                          :key="index"
                        >
                          <el-col
                            :offset="3"
                            :xl="21"
                            :lg="21"
                            :md="21"
                            :sm="21"
                            :xs="21"
                          >
                            <span class="cv-info"
                              >- {{ mindset.selection }}</span
                            >
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.skills
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header">SKILLS</span>
                          </el-col>
                        </el-row>
                        <el-row
                          v-for="(skill, index) in profile.configuration
                            .profileConfiguration.coreStrengthInformation
                            .skillsValue.workingPracticeSkills"
                          :key="index"
                        >
                          <el-col
                            :offset="3"
                            :xl="21"
                            :lg="21"
                            :md="21"
                            :sm="21"
                            :xs="21"
                          >
                            <el-row>
                              <el-col>
                                <span class="cv-info-label">{{
                                  skill.selection
                                }}</span>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col>
                                <span class="cv-info">{{
                                  skill.yearsOfExperience
                                }}</span>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row
                      class="centered"
                      style="margin-top:15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.hiddenTalents
                      "
                    >
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header"
                              >HIDDEN TALENTS</span
                            >
                          </el-col>
                        </el-row>
                        <el-row
                          v-for="(hiddenTalent, index) in profile.configuration
                            .profileConfiguration.coreStrengthInformation
                            .hiddenTalentsValue.skillsKnowledgeOutsideWork"
                          :key="index"
                        >
                          <el-col
                            :offset="3"
                            :xl="21"
                            :lg="21"
                            :md="21"
                            :sm="21"
                            :xs="21"
                          >
                            <span class="cv-info">- {{ hiddenTalent }}</span>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row  class="centered"
                      style="margin-top: 15px"
                      v-if="
                        profile.configuration.profileConfiguration
                          .coreStrengthInformation.technologies
                      ">
                      <el-col>
                        <el-row class="narrow-15">
                          <el-col>
                            <span class="cv-section-header"
                              >TECHNOLOGIES</span
                            >
                          </el-col>
                        </el-row>
                        <el-row
                          v-for="(technology, index) in profile.configuration
                            .profileConfiguration.coreStrengthInformation
                            .technologiesValue.userTechnologies"
                          :key="index"
                        >
                          <el-col
                            :offset="3"
                            :xl="21"
                            :lg="21"
                            :md="21"
                            :sm="21"
                            :xs="21"
                          >
                          <el-row>
                              <el-col>
                                <span class="cv-info-label">{{
                                  technology.selection
                                }}</span>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col>
                                <span class="cv-info">{{
                                  technology.yearsOfExperience
                                }}</span>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>

                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="center"
              style="width: 80%; margin-top: 40px; margin-bottom: 30px"
            >
              <el-col :xl="1" :lg="1" :md="1" :sm="1" :xs="2">
                <el-button class="btn-details-secondary" @click="exportProfile"
                  >Export</el-button
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="not-available centered" v-else>
          <el-col :xl="15" :lg="10" :md="10" :sm="10">
            <el-row>
              <el-col style="text-align: center">
                <span>
                  <i class="fas fa-user-alt-slash fa-5x"></i>
                </span>
              </el-col>
            </el-row>
            <el-row style="text-align: center">
              <el-col>
                <span class="title">User Profile Not Available</span>
              </el-col>
            </el-row>
            <el-row style="text-align: center">
              <el-col>
                <span class="description"
                  >User has not set the profile to be available online</span
                >
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="image"
      :UserInfo="userInfo"
      :ShowProfile="
        profile.configuration.profileConfiguration.personalInformation
          .profilePhoto
      "
    ></JobSeekerCV>
  </div>
</template>
<script>
import $ from "jquery";
import dataDelimiter from "@/utils/data.utils";
import JobSeekerCV from "../../sga-questionnaire/components/JobSeekerCV.vue";

export default {
  components: {
    JobSeekerCV
  },
  data() {
    return {
      profile: {
        configuration: {
          profileConfiguration: {
            personalInformation: {}
          }
        }
      },
      userid: "",
      cvid: "",
      isPublic: true,
      userInfo: {},
      image: ""
    };
  },
  created() {
    var obj = {
      userid: this.$route.params.userid,
      cvid: this.$route.params.cvid
    };
    this.$store.dispatch("account/getprofiledetails", obj).then(res => {
      this.profile = res;
      this.isPublic = this.profile.isProfilePublic;
    });

    this.$store.dispatch("sga/getPublicCodeHeaderDetails");

    if ($(".class_Others").length != 0) {
      var label_other = document.getElementById("task_id_Others");
      label_other.style.display = "block";
    }
  },
  computed: {
    currentSga() {
      return this.profile.survey;
    },
    selectedRoleCode() {
      return (
        this.profile.survey.sgaEmployeeInfo.employeeRoleONETCode.split(",") ||
        []
      );
    },
    selectedRoleDesc() {
      const roleTitle = this.profile.survey.sgaEmployeeInfo.employeeRoleTitle || "";
      return roleTitle.split(dataDelimiter) || [];
    },
    certificates() {
      return this.$store.state.sga.certificates;
    },
    currentRoleCodes() {
      if (this.profile.survey.sgaEmployeeInfo.employeeRoleONETCode == null)
        return null;
      var rolecode = this.profile.survey.sgaEmployeeInfo.employeeRoleONETCode.split(
        ", "
      );
      rolecode.push("Others");
      return rolecode;
    },
    currentRoleTitle() {
      if (this.profile.survey.sgaEmployeeInfo.employeeRoleONETCode == null)
        return null;
      
      const roleTitle = this.profile.survey.sgaEmployeeInfo.employeeRoleTitle || "";
      var roleTitles = roleTitle.split(dataDelimiter);
      roleTitles.push("Others");

      return roleTitles;
    }
  },
  methods: {
    selectedRoleTitle(code) {
      if (code == "Others") return "Others";
      var roles = this.profile.survey.sgaEmployeeInfo.employeeRoleTitleCodeSequence.split(
        ","
      );
      var roleFormatted = "";
      var ctr = 0;
      roles.forEach(element => {
        if (element.trim() == code.trim()) {
          roleFormatted += this.selectedRoleDesc[ctr] + "/";
        }
        ctr++;
      });

      roleFormatted = roleFormatted.substring(0, roleFormatted.length - 1);
      return roleFormatted;
    },
    getCertificateDescription(id) {
      return this.certificates.find(c => c.id == id).description;
    },
    exportProfile() {
      this.userInfo = { fullName: this.profile.fullName };
      this.image = this.profile.image === "na" ? "" : this.profile.image;
      window.setTimeout(function() {
        window.print();
      }, 500);
    }
  }
};
</script>

<style scoped>
#task_id_Others {
  display: none;
}
</style>
